import styled from 'styled-components';

export const TitleWrapper = styled.div`
    flex-wrap: nowrap;
    align-items: center;
    column-gap: 8px;
`;

export const IconWrapper = styled.div`
    cursor: pointer;
`;
